module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/3/4-1c06ec08c0743d5a2c457e62959a0c53.jpg";